export class Line {
  constructor(svg, svgAux = null) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
  }

  lineZeroYZoom(_this) {
    const yt = _this.svgNode.y;
    _this.svgNode["xAxisLine"].attr("y1", yt(0)).attr("y2", yt(0));
  }

  customLine(lineData) {
    this.svg.lineGroup
      .selectAll(`line.line-${lineData.name}`)
      .data([lineData])
      .join(
        enter => {
          return enter
            .append("line")
            .attr("class", `zoom-line line-${lineData.name}`)
            .style("opacity", 1)
            .attr("stroke", lineData.strokeColor)
            .attr("stroke-width", lineData.strokeWidth)
            .style("shape-rendering", "crispEdges")
            .style("stroke-dasharray", lineData.dashArray)
            .attr("y1", this.svg.y(lineData.yMin))
            .attr("y2", this.svg.y(lineData.yMax));
        },
        update => {
          return update
            .attr("y1", this.svg.y(lineData.yMin))
            .attr("y2", this.svg.y(lineData.yMax));
        },
        exit => exit.remove()
      );
  }
}
